
const navbar = [
    {
        id: 1,
        mainLink: { link: '/', title: 'Strona główna' },
        subLink: [],
    },
    {
        id: 2,
        mainLink: { link: '/O-nas', title: 'O nas' },
        subLink: [
            { id: 1, link: '/O-nas', title: 'O nas' },
            { id: 2, link: '/RadaNaukowa', title: 'Rada naukowa' },
            { id: 3, link: '/Historia', title: 'Historia' },
            { id: 4, link: '/Legenda', title: 'Legenda' },
            { id: 5, link: '/Drzewo-Pokolen', title: 'Drzewo pokoleń' },
        ],
    },
    {
        id: 3,
        mainLink: { link: '/Muzeum', title: 'Muzeum' },
        subLink: [],
    },
    {
        id: 4,
        mainLink: { link: '/Uslugi', title: 'Oferta' },
        subLink: [],
    },
    {
        id: 5,
        mainLink: { link: '/Szkolenie', title: 'Program szkolenia' },
        subLink: [],
    },
    {
        id: 6,
        mainLink: { link: '/Gadziak', title: 'Gądziak w ogrodzie' },
        subLink: [],
    },
    {
        id: 7,
        mainLink: { link: '/Partnerzy', title: 'Partnerzy' },
        subLink: [
            { id: 1, link: '/Partnerzy', title: 'Partnerzy' },
            { id: 2, link: '/Partnerzy/Galeria', title: 'Galeria' },
        ],
    },
    {
        id: 8,
        mainLink: { link: '/Staze', title: 'Staże' },
        subLink: [
            { id: 1, link: '/Staze', title: 'Staże' },
            { id: 2, link: '/Staze/Formularz', title: 'Formularz' }, 
        ],
    },
    {
        id: 9,
        mainLink: { link: '/Psychologia-zieleni/Wywiad', title: 'Psychologia zieleni' },
        subLink: [
            { id: 1, link: '/Psychologia-zieleni/Wywiad', title: 'Wywiad z Psychologiem' },
            { id: 2, link: '/Psychologia-zieleni/Ogrodoterapia', title: 'Ogrodoterapia' },
            { id: 3, link: '/Psychologia-zieleni/Sesje', title: 'Sesje terapeutyczne' },
            { id: 4, link: '/Psychologia-zieleni/Joga', title: 'Joga' },
        ],
    },
    {
        id: 10,
        mainLink: { link: '/Skontaktuj-sie', title: 'Kontakt' },
        subLink: [],
    },
];

export default navbar;